<div
  class="card p-3 edit-state-pane rounded bg-white border-0"
  id="editWorflowStatePane">
  <div class="card-header bg-white border-0 pb-0">
    <h1 class="d-flex justify-content-between w-100 align-items-center">
      Edit {{ model?.transitionDetails?.name }} Transition
      <div>
        <span class="cursor-pointer me-3" (click)="deleteTransition()">
          <i class="fa fa-trash text-danger" ngbTooltip="Delete Transition"></i>
        </span>
        <span class="cursor-pointer" (click)="closeModal()">
          <i class="fa fa-close" ngbTooltip="Close Modal"></i>
        </span>
      </div>
    </h1>
  </div>
  <div class="card-body py-0 bg-white border-0">
    <form
      class="toggling-form"
      [formGroup]="form"
      (ngSubmit)="onLastStepEvent()">
      <formly-form
        [model]="model"
        [fields]="fields"
        [options]="options"
        [form]="form">
      </formly-form>
    </form>
  </div>
</div>
